/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MPRelationType = {
    TechnicalAddress: 'TechnicalAddress',
    Judicialaddress: 'Judicialaddress',
} as const;
export type MPRelationType = typeof MPRelationType[keyof typeof MPRelationType];

